import $ from "jquery";
import angular from "angular";
import "materialize-css";

const MaterialDropdownDirective = function ($parse, $timeout) {
    return function (scope, element, attrs) {
        $timeout(function () {
            const showHideDropdownOnFocus = $parse(attrs.ddShowhideOnFocus)();
            // if `dd-showhide-on-focus="true" then
            // set `hover : false` as the dropdown is expected to open on focus.
            const showOnHover = showHideDropdownOnFocus ? false : $parse(attrs.ddActivateOnHover)();
            const constrainWidth = $parse(attrs.ddConstrainWidth)();

            element.dropdown({
                inDuration: attrs.ddInDuration || 300,
                outDuration: attrs.ddOutDuration || 225,
                constrainWidth: constrainWidth, // Does not change width of dropdown to that of the activator, Changed this as part of the material upgrade to version 0.100.2 as per new syntax.
                hover: showOnHover, // Activate on hover
                gutter: attrs.ddGutter || 0, // Spacing from edge
                belowOrigin: $parse(attrs.ddBelowOrigin)(), // Displays dropdown below the button
                alignment: attrs.ddAlignment || 'left' // Displays dropdown with edge aligned to the left of button
            });

            // Adding click event on the dropdown activator element to close any open dropdowns.
            // This is required because the dropdown in some pages are placed on the Accordion header and the attribute 'data-stoppropogation=true' is added to the element
            // to prevent the Accordion from closing/opening when clicking on the dropdown element. Because the event is not propogated by the dropdown element having this attribute,
            // any open dropdowns do not close when clicking on the next dropdown.
            element.click(function () {
                $(".dropdown-content").each(function () {
                    if (this.id !== attrs.activates) {
                        $(this).hide();
                    }
                });
                // This is for dropdowns on Accordion headers, where the menu sometimes breaks into next line or
                // the dropdown opens with a scroll bar.
                // Apply this style only if the element requests `dd-constrain-width="false"`, if applied by default
                // then the dropdown width varies based on the content inside. (Not suitable for dropdowns where consistent width is expected).
                if (!constrainWidth)
                    $("#" + attrs.activates).addClass("dropdown-content-max-width");
            });

            if (!showHideDropdownOnFocus)
                return;

            // Disable the Materialize built-in click handler
            // note: the event id is constructed to match the value used by `materialize.js`
            const origin = element;
            origin.off('click.' + origin.attr('id'));

            // Having disabled the default click handler, add event handlers to control
            // the display/hiding of the dropdown based on the focus of the input element.
            origin.on('focus', (e) => {
                origin.dropdown('open');
            });
            origin.on('blur', (e) => {
                origin.dropdown('close');
            });

            const activates = angular.element(document.querySelector('#' + origin.attr('data-activates')))
            // Prevent the selection of dropdown elements from propogating into a blur event that
            // would prevent the processing of the list element click event.
            // note: the `mousedown` event is propogated up from the child `<li>` elements to
            // the parent `data-activates` element.
            activates.on('mousedown', (e) => {
                // `mousedown` precedes the `blur` event, which we want:
                //      mousedown -> blur -> mouseup -> click
                e.preventDefault();
            });
            // After the click event on the list item has been processed, manually trigger a
            // blur on the origin element.
            // This is necessary due to the preceding suppression of default event processing
            // on the bubbled mousedown.
            activates.on('click', 'li', (e) => {
                origin.blur();
            });

            // Once the dropdown has been shown, after a delay, Materialize adds a further
            // document-level click handler (which serves to hide the dropdown).
            // When the dropdown is shown in response to a mouse click giving focus to the
            // origin, this unwanted event handling is liable to prompt the immediate close of
            // the just-shown dropdown, so it is hereby suppressed by preventing event propagation
            // bubbling up to the document.
            origin.on('click', (e) => {
                e.stopPropagation();
            });
        });
    };
};

MaterialDropdownDirective.$inject = ["$parse", "$timeout"];

export { MaterialDropdownDirective };